module.exports = __webpack_public_path__ + "img/机构权限.aa5a7b51.svg";